import { computed, Injectable, signal } from "@angular/core";
import { PUBLIC_COPY } from "../constants/public-copy.constants";

export type SupportedLanguage =
  "en" | "es" | "de" | "fr" | "it" | "pt-br" | "ja";

export interface LanguageOption {
  code: SupportedLanguage;
  label: string;
  nativeLabel: string;
}

export const LANGUAGES: readonly LanguageOption[] = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "es", label: "Spanish", nativeLabel: "Español" },
  { code: "de", label: "German", nativeLabel: "Deutsch" },
  { code: "fr", label: "French", nativeLabel: "Français" },
  { code: "it", label: "Italian", nativeLabel: "Italiano" },
  {
    code: "pt-br",
    label: "Portuguese (Brazil)",
    nativeLabel: "Português (BR)",
  },
  { code: "ja", label: "Japanese", nativeLabel: "日本語" },
];

@Injectable({ providedIn: "root" })
export class LanguageService {
  readonly language = signal<SupportedLanguage>("en");
  readonly options = LANGUAGES;
  readonly copy = computed(() => PUBLIC_COPY[this.language()]);

  select(language: SupportedLanguage) {
    this.language.set(language);
    if (typeof document !== "undefined")
      document.documentElement.lang = language;
  }
}
